var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPagePrev = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66569 0.292893C7.05621 0.683417 7.05621 1.31658 6.66569 1.70711L2.37279 6L6.66569 10.2929C7.05621 10.6834 7.05621 11.3166 6.66569 11.7071C6.27516 12.0976 5.642 12.0976 5.25147 11.7071L0.322182 6.77782C-0.107393 6.34824 -0.107395 5.65176 0.322182 5.22218L5.25147 0.292893C5.642 -0.0976311 6.27516 -0.0976311 6.66569 0.292893Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPagePrev);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/page-prev.959ef372bc4786ee41d916211e1a9204.svg";